import { Actions } from '../actionTypes/actionTypes';
import type { SessionExpiredAction, SessionExpiredTrigger } from './types';

export const sessionExpired = (trigger: SessionExpiredTrigger): SessionExpiredAction => ({
    type: Actions.SESSION_EXPIRED as SessionExpiredAction['type'],
    payload: { trigger }
});
